import React from "react";
import styles from "./Projects.module.css";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import tata1mg from "../../Assets/tata1mg.png";
import black from "../../Assets/black.png";
import reliance from "../../Assets/reliance.png";
import indeed from "../../Assets/indeed.png";

const Projects = () => {
  return (
    <div className={styles.projects}>
      <h1 className={styles.heading}>Projects</h1>
      <div className={styles.mainCard}>
        <div className={styles.cardLeft}>
          <img src={black} style={{ borderRadius: "10px" }}></img>
        </div>
        <div className={styles.cardRight}>
          <h1>Black Pearl</h1>
          <p>
            Black Pearl is a clone of CaratLane. CaratLane was founded, to give
            women access to modern, fine jewellery, that was also wearable
            everyday. Today CaratLane is India's largest omni-channel jeweller.
            CaratLane also has over 165 retail stores across 66+ Indian cities.
          </p>
          <p style={{ marginTop: "5%" }}>
            Tech Stack - HTML | CSS | JavaScript | React
          </p>
          <div className={styles.proLinks}>
            <a
              href="https://github.com/nikhildeora/black-pearl"
              target="_blank"
            >
              <FaGithub style={{ marginRight: ".5vw" }} />
              Github
            </a>

            <a
              href="https://startling-tulumba-8a76b2.netlify.app/"
              target="_blank"
            >
              <FaExternalLinkAlt style={{ marginRight: ".5vw" }} />
              Deployed
            </a>
          </div>
        </div>
      </div>
      <div className={styles.mainCard}>
        <div className={styles.cardLeft}>
          <img src={tata1mg} style={{ borderRadius: "10px" }}></img>
        </div>
        <div className={styles.cardRight}>
          <h1>TATA 1 MG</h1>
          <p>
            1mg.com brings to you an online platform, which can be accessed for
            all your health needs. We are trying to make healthcare a
            hassle-free experience for you. Get your allopathic, ayurvedic,
            homeopathic medicines, vitamins & nutrition supplements and other
            health-related products delivered at home. Lab tests? That too in
            the comfort of your home.
          </p>
          <p style={{ marginTop: "5%" }}>
            Tech Stack - HTML | CSS | JavaScript | React | Chakra UI | Bootstrap
          </p>
          <div className={styles.proLinks}>
            <a
              href="https://github.com/aayyuusshh21/screeching-poison-8463"
              target="_blank"
            >
              <FaGithub style={{ marginRight: ".5vw" }} />
              Github
            </a>

            <a
              href="https://fantastic-sunflower-ebd594.netlify.app/"
              target="_blank"
            >
              <FaExternalLinkAlt style={{ marginRight: ".5vw" }} />
              Deployed
            </a>
          </div>
        </div>
      </div>
      <div className={styles.mainCard}>
        <div className={styles.cardLeft}>
          <img src={reliance} style={{ borderRadius: "10px" }}></img>
        </div>
        <div className={styles.cardRight}>
          <h1>Reliance Digital</h1>
          <p>
            Reliance Digital is India's largest electronics retailer Network of
            400+ stores nationally, housing over 200 brands and 5000 products.
            From in-depth, expert buying advice to personal after-sales care
            tailored to each customer, we commit to our promise of
            'Personalising Technology' every day.
          </p>
          <p style={{ marginTop: "5%" }}>
            Tech Stack - HTML | CSS | JavaScript | React | Material UI
          </p>
          <div className={styles.proLinks}>
            <a
              href="https://github.com/aayyuusshh21/Reliance-Digital-Clone"
              target="_blank"
            >
              <FaGithub style={{ marginRight: ".5vw" }} />
              Github
            </a>

            <a
              href="https://effortless-faloodeh-93a106.netlify.app/"
              target="_blank"
            >
              <FaExternalLinkAlt style={{ marginRight: ".5vw" }} />
              Deployed
            </a>
          </div>
        </div>
      </div>
      <div className={styles.mainCard}>
        <div className={styles.cardLeft}>
          <img src={indeed} style={{ borderRadius: "10px" }}></img>
        </div>
        <div className={styles.cardRight}>
          <h1>Indeed.com</h1>
          <p>
            Indeed is the #1 job site in the world1 with over 300M unique
            visitors every month2. Indeed strives to put job seekers first,
            giving them free access to search for jobs, post resumes, and
            research companies. Every day, we connect millions of people to new
            opportunities.
          </p>
          <p style={{ marginTop: "5%" }}>
            Tech Stack - HTML | CSS | JavaScript | React | Chakra UI
          </p>
          <div className={styles.proLinks}>
            <a
              href="https://github.com/ankitraju123/vengeful-anger-1431"
              target="_blank"
            >
              <FaGithub style={{ marginRight: ".5vw" }} />
              Github
            </a>

            <a href="https://jade-diii.netlify.app/" target="_blank">
              <FaExternalLinkAlt style={{ marginRight: ".5vw" }} />
              Deployed
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
